import React from 'react';
import { LoaderStyled, PosterLoader } from './Loader.styled';

interface Props {
    poster?: string;
    className?: string;
    size?: number;
    children?: React.ReactNode;
}

export default function Loader({ poster, className = '', size = 40, children }: Props) {
    if (poster) {
        return (
            <PosterLoader
                className="h-100 w-100"
                style={{
                    backgroundImage: `url(${poster})`,
                }}
            />
        );
    }
    return (
        <div
            className={`position-relative overflow-hidden d-inline-block ${className}`}
            style={{ width: size, height: size }}
        >
            <LoaderStyled />
            <div
                className="d-flex align-items-center justify-content-center position-absolute h-100 w-100 text-center small"
                style={{ top: 0 }}
            >
                {children}
            </div>
        </div>
    );
}
